<template>
  <StepTitle>
    <div v-if="!isEnhancedContent" v-html="session && session.label" class="how-can"></div>
    <template v-if="!isEnhancedContent && session && session.subtitle" #subtitle>
      <div v-html="session.subtitle"  class="option"></div>
    </template>
    <template v-if="session && session.content && session.content.length" #content>
      <b-row class="justify-content-center">
        <b-col :class="{'col-md-10 col-lg-8 col-xl-6': !isEnhancedContent}"
          v-html="session.content">
        </b-col>
      </b-row>
    </template>
  </StepTitle>
</template>

<script>
import { mapState } from 'vuex'
import StepTitle from './StepTitle'

export default {
  name: 'SessionContent',
  components: {StepTitle},
  computed: {
    ...mapState(['session']),
    isEnhancedContent: function() {
      return this.session && !!this.session['enhanced_mode']
    }
  }
}
</script>
<style scoped>
</style>
